import { Spinner } from '@forest/shared/solid'
import { onMount } from 'solid-js'

/**
 * The non-dismissible blocking state shown while an IAP command is in
 * flight (GLOSSARY.md: Shop IAP processing overlay). Modality comes from
 * the enclosing overlay scene (inert siblings, full-viewport cover); this
 * overlay only takes focus so Escape/Tab land nowhere actionable. Its
 * spinner follows the platform's native style — the one Shop spinner that
 * does, because it stands in for the store sheet's own progress UI.
 */
export function ProcessingOverlay() {
  let overlay!: HTMLDivElement

  onMount(() => {
    // Let the outgoing shared dialog finish its close-side focus work before
    // The overlay takes modality. Its close explicitly suppresses restoration.
    queueMicrotask(() => {
      if (overlay.isConnected) overlay.focus({ preventScroll: true })
    })
  })

  return (
    <div
      ref={(element) => {
        overlay = element
      }}
      data-testid="iap-processing-overlay"
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
      class="fixed inset-0 z-40 grid place-items-center bg-black/45 outline-none duration-200 animate-in fade-in"
    >
      <span aria-label="Processing purchase" role="status">
        <Spinner class="size-9 text-[#20BFB2]" variant="platform" />
      </span>
    </div>
  )
}
